module.exports = __webpack_public_path__ + "static/img/4.a45eab90.jpg";